'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};



/*****************
 ** WEBPACK FOOTER
 ** ./~/chart.js/src/charts/Chart.Bubble.js
 ** module id = 185
 ** module chunks = 0
 **/